import React from "react";
import {
  Box,
  CssBaseline,
  Grid,
} from "@mui/material";

import { mainLayoutStyles } from "../../../../constants";
import Sidebar from "../../../../common/Sidebar";
import DetailsPageHeader from "../../../../common/DetailsPageHeader";
import HelpContent from "../../components/HelpContent/HelpContent";

const HelpContainer = () => {
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <DetailsPageHeader
        mainTitle={"Help Resources"}
        bgColor="#fff"
      />
      <Sidebar />
      <Grid
        container
        style={{ ...mainLayoutStyles, background: "#fff", paddingTop: 80 }}
      >
        <Grid container direction={"column"}>
          <HelpContent />
        </Grid>
      </Grid>
    </Box>
  );
};

export default HelpContainer;
